module.exports = __webpack_public_path__ + "img/table.3f699aa1.png";